import { useSearchParams } from 'react-router-dom'

import { useCheckNonIdeaChartMissingConfig } from '../../../hooks/use-check-non-idea-chart-missing-config'
import { QuotePortalComponents } from '../PortalComponents'
import { QuoteContextProvider } from '../QuoteContext'
import { useStockDetailUpdater } from '../hooks/use-stock-detail-updater'
import { useToggleRatings } from '../hooks/useToggleRatings'
import { QuoteQuery } from '../types'

export default function QuoteSharedWrapper() {
  useCheckNonIdeaChartMissingConfig()
  useToggleRatings()

  const [query] = useSearchParams()
  const tickers = query.get(QuoteQuery.Ticker)!.split(',')
  const { isStockDetailUpdating } = useStockDetailUpdater()

  return tickers.map((ticker, index) => (
    <QuoteContextProvider key={ticker} ticker={ticker} index={index}>
      <QuotePortalComponents isStockDetailUpdating={isStockDetailUpdating} />
    </QuoteContextProvider>
  ))
}
